export default __webpack_public_path__ + "static/media/founder__info-icon.aed230f7.svg";